import { render, staticRenderFns } from "./new_footer.vue?vue&type=template&id=115e9848&scoped=true&"
import script from "./new_footer.vue?vue&type=script&lang=js&"
export * from "./new_footer.vue?vue&type=script&lang=js&"
import style0 from "./new_footer.vue?vue&type=style&index=0&id=115e9848&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "115e9848",
  null
  
)

export default component.exports